import { Account, AccountAlert } from "../../interfaces";

/**
 * Alerts drivingStyle and impact are now deprectated.
  To support old data i would like:
  - if impact is true, we add IMPACT to events array
  - if drivingStyle is not empty, we add BRAKING, ACCELERATION and CORNERING to events array
  - if the accout has legacy alert setup, we set sendEmailNotification to true
 * @param account 
 * @returns account alert settings
 */
export const populateNewAlertSettings = (
  account: Account | undefined
): AccountAlert => {
  if (!account || !account.alerts) {
    return {
      events: [],
      recipients: [],
      sendEmailNotification: false,
      sendPushNotification: false,
    };
  }

  const originalEvents = account.alerts.events ?? [];
  const events = [
    ...originalEvents,
    ...(account.alerts.impacts ? ["IMPACT"] : []),
    ...(account.alerts.drivingStyle?.length
      ? ["BRAKING", "ACCELERATION", "CORNERING"]
      : []),
  ];

  const legacyEmailNotificationSetup =
    account.alerts.impacts || (account.alerts.drivingStyle?.length ?? 0) > 0;

  return {
    ...account.alerts,
    events,
    recipients: account.alerts.recipients ?? [],
    sendEmailNotification:
      legacyEmailNotificationSetup ||
      account.alerts.sendEmailNotification ||
      false,
    sendPushNotification: account.alerts.sendPushNotification || false,
  };
};
